import React, { useEffect, useState } from "react";
import { Segment, Grid } from "semantic-ui-react";
import { observer } from "mobx-react-lite";
import LoadingComponent from "../../../app/layout/LoadingComponent";
import agent from "../../../app/api/agent";
import { IPayrollDetail } from "../../../app/models/trackPayroll";

interface IProps {
  id: string;
}

const General: React.FC<IProps> = ({ id }) => {
  const [payroll, setPayroll] = useState<IPayrollDetail | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadPayroll = async () => {
      try {
        const data = await agent.Payroll.getPayrollById(id);
        setPayroll(data);
      } catch (error) {
        console.error("Error loading payroll:", error);
      } finally {
        setLoading(false);
      }
    };

    loadPayroll();
  }, [id]);

  if (loading || payroll === null) {
    return <LoadingComponent content="Cargando información de nómina..." />;
  }

  return (
    <div>
      <Segment className="grayborder">
        <Grid textAlign="center">
          <Grid.Row>
            <Grid.Column className="labelstyle">
              <p>Documento No. </p>
            </Grid.Column>
            <Grid.Column className="infostyle">
              <strong>{payroll.documentID}</strong>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column className="labelstyle">
              <p>Tipo de Nómina </p>
            </Grid.Column>
            <Grid.Column className="infostyle">
              <strong>{payroll.payrollType}</strong>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column className="labelstyle">
              <p>Fecha Emisión </p>
            </Grid.Column>
            <Grid.Column className="infostyle">
              <strong>{payroll.issueDate}</strong>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column className="labelstyle">
              <p>Empleado </p>
            </Grid.Column>
            <Grid.Column className="infostyle">
              <strong>{payroll.employeeName}</strong>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column className="labelstyle">
              <p>Identificación </p>
            </Grid.Column>
            <Grid.Column className="infostyle">
              <strong>{payroll.employeeIdentification}</strong>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column className="labelstyle">
              <p>CUNE </p>
            </Grid.Column>
            <Grid.Column className="infostyle">
              <strong>{payroll.cune}</strong>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column className="labelstyle">
              <p>Valor Total </p>
            </Grid.Column>
            <Grid.Column className="infostyle">
              <strong>
                ${(payroll.documentValue || 0).toLocaleString("es-CO")} COP
              </strong>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column className="labelstyle">
              <p>Total Ingresos </p>
            </Grid.Column>
            <Grid.Column className="infostyle">
              <strong>
                ${(payroll.totalRevenues || 0).toLocaleString("es-CO")} COP
              </strong>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column className="labelstyle">
              <p>Total Descuentos </p>
            </Grid.Column>
            <Grid.Column className="infostyle">
              <strong>
                ${(payroll.totalDiscounts || 0).toLocaleString("es-CO")} COP
              </strong>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column className="labelstyle">
              <p>Estado </p>
            </Grid.Column>
            <Grid.Column className="infostyle">
              <strong>{payroll.resultCodeMessage}</strong>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Segment>
    </div>
  );
};

export default observer(General);
